jQuery(document).ready(function ($) {
  
$('#custom-text-area-1').on('input propertychange', function(){
        // Print entered value in a div box
        $("#preview-custom-text-area-1").text($(this).val());
    });
  /*
  $('#custom-text-area-1').on('change', function() {
    var $custom_text_val = $(this).val();
    $('#preview-custom-text-area-1').text($custom_text_val);
  });
  */
  $('.main-menu-item').click(function() {
    $('.main-menu-item').removeClass('is-active');
    $(this).addClass('is-active');
    $target_sub_menu = $(this).attr('target-submenu');
    $('.sub-menu').prop('hidden', true);
    $($target_sub_menu).prop('hidden', false);
    console.log($target_sub_menu);
  });
  $(document).on('click', '.page-next', function() {
    $next_url = $(this).attr('href');
    $current_title = $(document).attr('title');
    $(this).attr('disabled', 'disabled');
    $('.page-next span').addClass('uk-hidden');
    $('.page-next .uk-spinner').removeClass('uk-hidden');
    history.pushState({urlPath: $next_url},"",$next_url);
    //gtag('config', g_analytics, {'page_title' : $current_title , 'page_path': $next_url});
    fetch__more_items();
    return false;
  });
  
  if ($('body').hasClass('tmp-product')) {
    $(document).on('click', '.uk-bundle-thumbnail', function(){
      //$('.uk-bundle-thumbnail').click(function() {
      $('.variant-spinner').prop('hidden', false);
      $('.uk-bundle-element').hide();
    });
    $('#add-to-bag').click(function() {
      $(this).prop('disabled', true);
      $('#add-to-bag span').addClass('uk-hidden');
      $('#add-to-bag .uk-spinner').removeClass('uk-hidden');
      ajax__addtocart();
      return false;
    });
    $('.option-selector').click(function() {
      var option_image_target = $(this).attr('data-image-src-target');
      var option_image_src = $(this).attr('data-image-src');
      var option_text_target = $(this).attr('data-text-target');
      var option_text = $(this).attr('data-text');
      var option_price_target = $(this).attr('data-price-target');
      var option_price = $(this).attr('data-price');
      var option_value_target = $(this).attr('data-value-target');
      var option_value = $(this).attr('data-value');
      var option_add_class = $(this).attr('data-add-class');
      var option_remove_class = $(this).attr('data-remove-class');
      $(option_image_target).attr('src', option_image_src).addClass(option_add_class).removeClass(option_remove_class);
      $(option_text_target).text(option_text).addClass('uk-text-semibold');
      $(option_value_target).val(option_value);
      $(option_price_target).text(option_price);
    });
    $('.option-input').click(function() {
      var option_value_target = $(this).attr('data-value-target');
      var option_value_source = $(this).attr('data-value-source');
      $(option_value_target).text($(option_value_source).val()).addClass('uk-text-semibold');
    });
    // fix tables
    $('table').attr('width', '100%').attr('height', 'auto');
    $('table th').css('width', '');
    $('table td').css('width', '');
  }
  if ($('body').is('.tmp-product, .not-in-collection')) {
    //console.log('not in collection');
    //fetch__item_collections();
    //fetch__item_related_items();
  }
  $('#newsletter_opt_in').submit(function(e) {
    var url = 'https://api.ki7en.com/opt-in/';
    //'https://api4.rarelogic.com/shop/pussheuk/customer_lists/4b058a48-a156-11e8-b7ee-4d40930ec96c/subscribe';
    $.ajax({
      type: 'GET',
      url: url,
      data: $('#newsletter_opt_in').serialize(),
      success: function(data__optin)
      {
        $('#newsletter_opt_in_form .dyn.opt_in_status').html(data__optin.status_msg);
      },
      error: function (data__optin) {
        $('#newsletter_opt_in_form .dyn.opt_in_status').html('Please enter your email');
      }
    });
    e.preventDefault();
  });

  
});
function ajax__addtocart() {
  $.ajax({
    url: '/cart/add.js',
    method: 'POST',
    dataType: 'json',
    data: $('#add-to-bag-form').serialize()
  }).done(function() {
    UIkit.notification({message: '<span uk-icon=\'icon: check\'></span> Added to your shopping bag', status: 'success', pos: 'top-center', timeout: 1500});
    $.getJSON('/cart.js', function(cart) {
  	  $('.dyn_cart_count').html(cart.item_count);
	});
  }).fail(function() {
    UIkit.notification({message: '<span uk-icon=\'icon: warning\'></span> Please make sure you select options', status: 'warning', pos: 'top-center', timeout: 1500});
  }).always(function() {
    $('#add-to-bag').prop('disabled', false);
    $('#add-to-bag span').removeClass('uk-hidden');
    $('#add-to-bag .uk-spinner').addClass('uk-hidden');
  });
  
  //cart__update_qty();
}
function fetch__item_collections() {
  /*
  var $item_id = $('#item_signals').attr('data-item-id');
  var $store_id = $('#item_signals').attr('data-store-id');
  var jqxhr = $.getJSON('https://api.ki7en.com/icollection/?id=' + $item_id + '&sid=' + $store_id, function(item_collections) {
    $.each(item_collections, function (index, value) {
      $('#discover-more').append($('<li class=""></li>').html('<a class="uk-height-extramini uk-text-lineheight-extramini uk-text-black uk-display-block" href="/collections/' + value.collection_url_key + '">' + value.collection_name + '</a>'));
    });
  });
  jqxhr.done(function () {
    $(document).trigger('fetch__item_collections_done');
  });
  */
}
function fetch__item_related_items() {
    $('#discover_more a').each(function() {
      var $collection_url = $(this).attr('href');
      console.log($collection_url);
      if ($collection_url.indexOf('new-in') == -1) {
        var jqxhr = $.getJSON('/' + $collection_url + '/products.json?limit=15', function(items_related) {
          $.each(items_related.products, function (index, value) {
            $('.related_items_carousel_box').append($('<figure class="related_item w230pxi fl"><a class="w100 h100 db p20px" href="/products/' + value.handle + '" title="' + value.title + '"><img class="w100 db" src="' + value.images[0].src + '"></a></li>'));
            //n = n+1;
          });
        }).done(function () {
          console.log('fetch__item_related_items complete');
        });
      }
    });
}
function fetch__more_items() {
  $.ajax({
    url: $next_url,
    success: function(data) {
      $('.catalog-pagination').remove();
      items = $(data).find('.catalog-item');
      $('#collection-products-grid-inner').append(items);
      pagination = $(data).find('.catalog-pagination');
      $('#collection-products-grid-inner').append(pagination);
      //ga('send', 'pageview', $next_url);
      //history.pushState({urlPath: $next_url},"",$next_url);
      //gtag('config', 'UA-79274266-10', {'page_title' : $current_title , 'page_path': $next_url});
    }
  });
}
